import Joi from 'joi';

export const blogEntrySchema = Joi.object({
  title: Joi.string().required(),
  excerpt: Joi.string().max(255).allow(''),
  text: Joi.string().required(),
  visibility: Joi.number().valid(1, 2, 3).required(), // 1: Both, 2: Operations, 3: Client
  storeable_asset_id: Joi.string().uuid().required(),
  image_caption: Joi.string().required(),
  published: Joi.boolean().required()
}).options({
  abortEarly: false
});
